import * as React from 'react';
import { SVGProps } from 'react';

const IconFolderOpenSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1h6a1 1 0 0 1 1 1v2h.706a1 1 0 0 1 .968 1.252l-1.563 6a1 1 0 0 1-.967.748H1ZM2 4h3v1h7v1H4.856a1 1 0 0 0-.967.748L2.52 12H2V4Z"
    />
  </svg>
);
export default IconFolderOpenSizeS;
